import * as angular from 'angular';
import {IController} from "angular";
import {ItinerariesTasksSettings} from "../../angular/models/itineraries-tasks-settings.model";

export class ItinerariesTasksSettingsPanelComponent implements IController {
  settings: ItinerariesTasksSettings;
  onSettingsChange: Function;

  public queryString: string;
  public sections: any;


  /* @ngInject */
  constructor(private $mdPanel) {
  }

  $onInit() {

    this.sections = angular.copy(this.settings.sections)

  }


  onShowPanel($event) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.OFFSET_START,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.show-button')
      .withAnimation(this.$mdPanel.animation.FADE);

    const config = {
      locals: {
        data: {
          sections: this.sections,
          queryString: this.queryString,
          parentScope: this
        },

        onClose: this.onClosePanel
      },
      attachTo: angular.element(document.body),
      controller: ItinerariesTasksSettingsCtrl,
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: require('./template/panel-template.html').default,
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, reason) => {
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onClosePanel(settingsConfig, parentScope) {
    parentScope.onSettingsChange({
      settings: settingsConfig
    })
  }

}

class ItinerariesTasksSettingsCtrl implements IController {

  public filteredSections: any;
  private settingsConfig: any;
  private queryString: string;


  constructor(private mdPanelRef, private deliveriesConstants, private $filter) {

  }

  $onInit() {


    this.settingsConfig = {
      sections: this.mdPanelRef.config.locals.data.sections

    };
    this.filteredSections = this.settingsConfig.sections;
    this.queryString = this.mdPanelRef.config.locals.data.queryString
  }

  onQueryStringChange(query) {

    this.queryString = query
    this.filteredSections = this.onFilter(query);
    // this.settingsCopy
  }

  onFilter(query) {
    let sectionsCopy = angular.copy(this.settingsConfig.sections)
    if (query) {
      Object.entries(this.settingsConfig.sections).forEach(([key, value], index) => {
        if (!this.$filter('translate')(`ITINERARIES_TASK_SECTIONS.${key}`).toLowerCase().includes(query)) {
          delete sectionsCopy[key]
        }
      });
    }

    return sectionsCopy;
  }
  onSectionChanged(key,value) {
    this.settingsConfig.sections[key] = value;
    this.mdPanelRef.config.locals.data.parentScope.onSettingsChange({settings:this.settingsConfig})
  }


  cancel() {
    this.mdPanelRef.close();
  }

}

angular
  .module('bringoz.admin.itineraries')
  .component('itinerariesTasksSettingsPanel', {
    bindings: {
      settings: '<',
      onSettingsChange: '&'
    },
    template: require('./itineraries-tasks-settings-panel.html').default,
    controller: ItinerariesTasksSettingsPanelComponent
  });
